import React, { FC } from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import { useTheme } from "@material-ui/core";

type Props = {
  fill?: string;
};

const CheckmarkIcon: FC<SvgIconProps & Props> = ({ fill, ...props }: Props) => {
  const theme = useTheme();
  const fillColor = fill || theme.palette.primary.main;

  return (
    <SvgIcon {...props} width="17" height="17" viewBox="0 0 17 17">
      <path
        fill={fillColor}
        d="M5 11.21L0 6.21 1.41 4.8 5 8.38 12.59 0.79 14 2.21z"
        transform="translate(1.5 2.5)"
      />
    </SvgIcon>
  );
};

export default CheckmarkIcon;
